<template>
  <component :is="typeData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="typeData === undefined">
      <h4 class="alert-heading">
       {{ $t('Error fetching type data')}}
      </h4>
      <div class="alert-body">
        {{ $t('No type found with this type id. Check')}}
        <b-link class="alert-link" :to="{ name: 'types_index'}">
          {{ $t('Type List')}}
        </b-link>
        {{ $t('for other types.')}}
      </div>
    </b-alert>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <!-- Form -->
    <b-form v-if="typeData" @submit.prevent="submit">

      <!-- Name ar -->
      <b-form-group :label="$t('Name')" label-for="name">
        <b-form-input
            id="name"
            v-model="typeData.name"
            autofocus
            :state="errors && ('name' in errors) ? false : null"
            trim
            autocomplete="off"
            placeholder=""
        />

        <b-form-invalid-feedback :state="errors && ('ar_name' in errors) ? false : null">
          {{ errors && ('name' in errors) ? $t(errors.name[0]) : null }}
        </b-form-invalid-feedback>

      </b-form-group>





      <!-- description ar -->
      <b-form-group :label="$t('Description')" label-for="ar_description">
        <b-form-textarea
            id="description"
            :placeholder="$t('description')"
            v-model="typeData.description"
            :state="errors && ('description' in errors) ? false : null"
            trim
            rows="3"
        />

        <b-form-invalid-feedback :state="errors && !('description' in errors)">
          {{ errors  && ('description' in errors) ? $t(errors.description[0]) : null }}
        </b-form-invalid-feedback>
      </b-form-group>




      <!-- category -->
      <b-form-group
          :label="$t('Category')"
          label-for="category"
          :state="null"
      >
        <v-select
            v-model="typeData.category"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="categoriesOptions"
            :clearable="false"
            input-id="category"
        />
        <b-form-invalid-feedback :state="errors && !('category' in errors)">
          {{ errors && ('category' in errors) ? $t(errors.category[0]) : null }}
        </b-form-invalid-feedback>
      </b-form-group>


      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
            variant="primary"
            class="mr-2"
            type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>
    </b-form>


  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BFormInput, BForm, BFormTextarea,
    BFormInvalidFeedback
} from 'bootstrap-vue'
import { ref, onUnmounted, watch } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import typeStoreModule from '@/views/modules/type/typeStoreModule'

import { OrbitSpinner } from 'epic-spinners'
import useTypesList from '@/views/modules/type/types-list/useTypesList'
import useTypeEdit from '@/views/modules/type/types-edit/useTypeEdit'
import vSelect from 'vue-select'

export default {
  components: {
    BTab,
    BTabs,
    BFormTextarea,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BAlert,
    OrbitSpinner,
    BLink,

  },
  setup(props, { root }) {

    const typeData = ref(null)

    const errors = ref({})

    const requestStatus = ref(true)

    const TYPE_APP_STORE_MODULE_NAME = 'app-type'

    if (!store.hasModule(TYPE_APP_STORE_MODULE_NAME)) store.registerModule(TYPE_APP_STORE_MODULE_NAME, typeStoreModule)

    onUnmounted(() => {
      if (store.hasModule(TYPE_APP_STORE_MODULE_NAME)) store.unregisterModule(TYPE_APP_STORE_MODULE_NAME)
    })

    const { categoriesOptions } = useTypesList()

    const submit = () => {

      requestStatus.value = true
      errors.value = {}

      store.dispatch('app-type/editType', typeData.value).then(res => {
        requestStatus.value = false
        toaster(root.$i18n.t('Type Updated successfully'),
            'success',
            root.$i18n.t('Success'))

      }).catch(res => {
        errors.value = res.response.data
      }).finally(() => {
        requestStatus.value = false
      })
    }


    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    store.dispatch('app-type/fetchType', { id: router.currentRoute.params.id })
      .then(response => {
        typeData.value = response.data.type
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 404) {
          typeData.value = undefined
          requestStatus.value = false
        }
      })

    return {
      typeData,
      requestStatus,
      categoriesOptions,
      errors,
      submit
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
